var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0017 0C8.50397 0 0 8.50397 0 19.0017C0 29.496 8.50397 38.0034 19.0017 38.0034C29.4994 38.0034 38.0034 29.496 38.0034 19.0017C38 8.50397 29.496 0 19.0017 0ZM20.4326 35.067V33.7887C20.4326 32.9953 19.7917 32.3544 18.9983 32.3544C18.2049 32.3544 17.564 32.9953 17.564 33.7887V35.067C9.79923 34.3787 3.59757 28.1635 2.93299 20.3885H4.16722C4.96065 20.3885 5.6015 19.7477 5.6015 18.9542C5.6015 18.1608 4.96065 17.5199 4.16722 17.5199H2.93977C3.64504 9.78906 9.82975 3.61792 17.5674 2.93299V4.11975C17.5674 4.91318 18.2083 5.55403 19.0017 5.55403C19.7951 5.55403 20.436 4.91318 20.436 4.11975V2.93299C28.1736 3.61792 34.3583 9.78906 35.0636 17.5199H33.8362C33.0427 17.5199 32.4019 18.1608 32.4019 18.9542C32.4019 19.7477 33.0427 20.3885 33.8362 20.3885H35.0704C34.4024 28.1635 28.2008 34.3787 20.4326 35.067Z",
    fill: "#501E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.543 9.74494L19.0492 18.6456C19.0322 18.6456 19.0186 18.6422 19.0017 18.6422C18.8966 18.6422 18.7915 18.6524 18.6897 18.6728L11.5794 13.3018C11.108 12.9492 10.4333 13.0373 10.0739 13.5154C9.71445 13.9868 9.80939 14.6649 10.2841 15.0209L17.3945 20.3885C17.4623 21.2158 18.1574 21.8668 19.0017 21.8668C19.8934 21.8668 20.6157 21.1446 20.6157 20.2528C20.6157 20.2088 20.6123 20.1681 20.6089 20.1274L29.1027 11.2267C29.513 10.7961 29.4994 10.1179 29.0654 9.70425C28.6348 9.29736 27.9532 9.31432 27.543 9.74494Z",
    fill: "#501E72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5d78ce0a.svg";
export { ForwardRef as ReactComponent };